// This file is used as a shim of "BlobDownloadResponse" for some browser bundlers
// when trying to bundle "BlobDownloadResponse"
// "BlobDownloadResponse" class is only available in Node.js runtime
export var BlobDownloadResponse = 1;
//# sourceMappingURL=BlobDownloadResponse.browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@azure/storage-blob/dist-esm/src/BlobDownloadResponse.browser.js
// module id = 685
// module chunks = 0